/**
 * Lazy-loads per-page media registries from resources/pages/<scope>/media.json
 */
import type { MediaRegistryMap } from './types';

type RegistryModule = { default?: MediaRegistryMap } | MediaRegistryMap;

const loaders = import.meta.glob<RegistryModule>('../pages/*/media.json', {
  eager: false,
});

function normalizeModule(mod: RegistryModule): MediaRegistryMap {
  if (mod && typeof mod === 'object' && 'default' in mod && mod.default) {
    return mod.default as MediaRegistryMap;
  }
  return mod as MediaRegistryMap;
}

export async function loadScopedMediaRegistry(scope: string): Promise<MediaRegistryMap> {
  const path = `../pages/${scope}/media.json`;
  const loader = loaders[path];
  if (!loader) {
    throw new Error(`[MediaMaster] No registry at resources/pages/${scope}/media.json`);
  }
  const mod = await loader();
  return normalizeModule(mod);
}

export function listAvailableMediaScopes(): string[] {
  return Object.keys(loaders).map((k) => {
    const m = k.match(/pages\/([^/]+)\/media\.json$/);
    return m?.[1] ?? '';
  }).filter(Boolean);
}
